module.exports = __webpack_public_path__ + "static/media/silabs.bfc3c5ab.jpg";